export default "__VITE_ASSET__CVu2_IiR__"